import CONNECTION from '@/app/modules/login/api/apiUrls';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { replaceParameters } from '@/common-utils/functions/restUtils';

const mutationConnectAs = (onSuccess, onError) => {
    return {
        mutationFn: (userUuid) => {
            return client.post(replaceParameters(CONNECTION.CONNECT_AS.url, { userId: userUuid }));
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationConnectAs;